import React from 'react';
import PropTypes from 'prop-types';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  intlShape,
} from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './SkillEvaluationForm.scss';

const messages = defineMessages({
  title: {
    id: 'SkillEvaluationModal.title',
    defaultMessage: 'Estimate your skill level on course topic',
  },
  awfulLabel: {
    id: 'SkillEvaluationModal.awfulLabel',
    defaultMessage: 'Awful',
  },
  poorLabel: {
    id: 'SkillEvaluationModal.poorLabel',
    defaultMessage: 'Poor',
  },
  averageLabel: {
    id: 'SkillEvaluationModal.averageLabel',
    defaultMessage: 'Average',
  },
  goodLabel: {
    id: 'SkillEvaluationModal.goodLabel',
    defaultMessage: 'Good',
  },
  excellentLabel: {
    id: 'SkillEvaluationModal.excellentLabel',
    defaultMessage: 'Excellent',
  },
});

const SkillEvaluationForm = ({
  intl: { formatMessage },
  skillLevel,
  setSkillLevel,
  classes,
}) => {
  const marks = [
    {
      value: 1,
      label: formatMessage(messages.awfulLabel),
    },
    {
      value: 2,
      label: formatMessage(messages.poorLabel),
    },
    {
      value: 3,
      label: formatMessage(messages.averageLabel),
    },
    {
      value: 4,
      label: formatMessage(messages.goodLabel),
    },
    {
      value: 5,
      label: formatMessage(messages.excellentLabel),
    },
  ];

  return (
    <>
      <Typography className={cx(s.title, classes.title)} variant="h6">
        <FormattedMessage {...messages.title} />
      </Typography>
      <div
        className={cx(s.contentWrapper, classes.skillEvaluationContentWrapper)}
      >
        <Slider
          min={1}
          max={5}
          value={skillLevel}
          marks={marks}
          classes={{
            markLabel: cx(s.sliderMarkLabel, classes.sliderMarkLabel),
            root: cx(classes.sliderRoot),
            mark: cx(classes.mark),
          }}
          onChange={(e, value) => {
            setSkillLevel(value);
          }}
        />
      </div>
    </>
  );
};

SkillEvaluationForm.propTypes = {
  intl: intlShape.isRequired,
  setSkillLevel: PropTypes.func.isRequired,
  skillLevel: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    title: PropTypes.string,
    sliderRoot: PropTypes.string,
    sliderMarkLabel: PropTypes.string,
    skillEvaluationContentWrapper: PropTypes.string,
    mark: PropTypes.string,
  }),
};

SkillEvaluationForm.defaultProps = {
  classes: {},
};

export default injectIntl(withStyles(s)(SkillEvaluationForm));
